module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('ol', [_c('li', [_vm._v("Open your mobile chrome browser and type http://meherbabaapp.com/ ")]), _vm._v(" "), _c('li', [_vm._v("Follow the below steps to install Mobile App.")])])])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "align": "center",
      "src": "/static/doc-images/Instructions/ambppct final.gif",
      "alt": "This is an animated gif image, but it does not move"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2395c5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/instructions.vue
// module id = 318
// module chunks = 1